// extracted by mini-css-extract-plugin
export var editor = "_1j-0";
export var flowSidebar = "_5a-2";